import { getChainReactionState } from './chainReaction';
import './ChainReaction.css';
import CoreboundIcon from './CoreboundIcon';

const ChainReactionControl = ({ game, onToggle }) => {
  const state = getChainReactionState(game);
  if (!state.owned) return null;
  return (
    <div className={`coreboundChainSetup ${state.available ? 'is-ready' : ''}`}>
      <div>
        <strong>
          <CoreboundIcon name="chainReaction" /> Chain Reaction{' '}
          <small>SPECIAL · ACTIVE</small>
        </strong>
        <span role="status">
          {state.used
            ? 'Used · One activation per run'
            : state.armed
            ? 'Armed · Activates on your next non-Power Up landing'
            : 'Ready · Arm before a throw · One use for the entire run'}
        </span>
        <span>
          Good and bad neighboring tiles both trigger. Power Up landings keep
          the charge armed until the die lands on a different kind of tile.
        </span>
        <button
          type="button"
          onClick={onToggle}
          disabled={state.used || !onToggle}
        >
          {state.armed ? 'Cancel Chain Reaction' : 'Arm Chain Reaction'}
        </button>
      </div>
    </div>
  );
};

export default ChainReactionControl;
